import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import Checkbox from '../../../form/Checkbox'
import CheckboxGroup from '../../../form/CheckboxGroup'
import Input from '../../../form/Input'
import Select from '../../../form/Select'
import ColorPicker from '../../../../UniformComponents/ColorPicker'
import Slider from '../../../../UniformComponents/Slider'
import Typography from '../../../../UniformComponents/Typography'

const defaultColors = [
    '#97D100',
    '#FFDA10',
    '#FEB200',
    '#FD597F',
    '#D9314B',
    '#16CCC1',
]

const barDefaultColors = [
    '#16CCC1',
    '#715AF8',
    '#1A81F0',
    '#97D100',
    '#FFDA10',
    '#FEB200',
    '#FD597F',
    '#D9314B',
]

const sortByOptions = [
    { label: 'None', value: 'none' },
    { label: 'Name', value: 'name' },
    { label: 'Event End Date', value: 'endDate' },
    { label: 'Value', value: 'value' },
    { label: 'Group', value: 'tagOptionName' },
]

const sortDirections = [
    { label: 'Ascending', value: 1 },
    { label: 'Descending', value: -1 },
]

const formatOptions = [
    { label: 'Numeric', value: 'numeric' },
    { label: 'Currency', value: 'currency' },
    { label: '%', value: '%' },
]

const removeZeroNull = [
    { label: 'Do Not Remove', value: 'dontRemove' },
    { label: 'Remove Zeros', value: 'zero' },
    { label: 'Remove Null', value: 'null' },
    { label: 'Remove Both', value: 'both' },
]

const currencyOptions = [
    { label: 'USD', value: 'USD' },
    { label: 'GBP', value: 'GBP' },
    { label: 'EUR', value: 'EUR' },
    { label: 'AUD', value: 'AUD' },
]

const settingOptions = [
    {
        name: 'legend',
        label: 'Show legend',
        widgetRenderPath: 'showLegend',
        defaultValue: true,
        type: 'checkbox',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'pie', 'donut', 'radar', 'line', 'quadrantAnalysis'],
        group: 'Legend',
    },
    {
        name: 'boundaryGap',
        label: 'Boundary gap',
        widgetRenderPath: 'boundaryGap',
        defaultValue: true,
        type: 'checkbox',
        allowedCharts: ['line'],
        group: 'Style',
    },
    {
        name: 'showOptionLabels',
        label: 'Show option labels',
        widgetRenderPath: 'showOptionLabels',
        defaultValue: false,
        type: 'checkbox',
        allowedCharts: ['pie', 'donut'],
        group: 'Labels',
    },
    {
        name: 'showOptionLabels',
        label: 'Show option labels',
        widgetRenderPath: 'showOptionLabels',
        defaultValue: true,
        type: 'checkbox',
        allowedCharts: ['treemap'],
        group: 'Labels',
    },
    {
        name: 'showDataLabels',
        label: 'Show data labels',
        widgetRenderPath: 'showDataLabels',
        defaultValue: true,
        type: 'checkbox',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'pie', 'donut', 'radar', 'treemap', 'line'],
        group: 'Labels',
    },
    {
        name: 'hideOverlapLabels',
        label: 'Hide overlapping labels',
        widgetRenderPath: 'hideOverlapLabels',
        defaultValue: false,
        type: 'checkbox',
        allowedCharts: ['pie', 'donut'],
        group: 'Labels',
    },
    {
        name: 'labelPosition',
        label: 'Label Position',
        widgetRenderPath: 'labelPosition',
        defaultValue: 'inside',
        options: [{ label: 'Inside', value: 'inside' }, { label: 'Outside', value: 'outside' }],
        type: 'select',
        allowedCharts: ['pie', 'donut'],
        show: (widget) => (R.pathOr(false, ['widgetRenderSettings', 'showDataLabels'], widget)
            || R.pathOr(false, ['widgetRenderSettings', 'showOptionLabels'], widget)),
        group: 'Labels',
    },
    {
        name: 'labelPosition',
        label: 'Label Position',
        widgetRenderPath: 'labelPosition',
        defaultValue: 'inside',
        options: [{ label: 'Inside', value: 'inside' }, { label: 'Top', value: 'top' }, { label: 'Inside Top', value: 'insideTop' }],
        type: 'select',
        allowedCharts: ['column', 'stackedColumn'],
        show: (widget) => R.pathOr(false, ['widgetRenderSettings', 'showDataLabels'], widget),
        group: 'Labels',
    },
    {
        name: 'labelPosition',
        label: 'Label Position',
        widgetRenderPath: 'labelPosition',
        defaultValue: 'inside',
        options: [{ label: 'Inside', value: 'inside' }, { label: 'Right', value: 'right' }, { label: 'Inside Right', value: 'insideRight' }],
        type: 'select',
        allowedCharts: ['bar', 'stackedBar'],
        show: (widget) => R.pathOr(false, ['widgetRenderSettings', 'showDataLabels'], widget),
        group: 'Labels',
    },
    {
        name: 'labelPosition',
        label: 'Label Position',
        widgetRenderPath: 'labelPosition',
        defaultValue: 'top',
        options: [{ label: 'Top', value: 'top' }, { label: 'Bottom', value: 'bottom' }],
        type: 'select',
        allowedCharts: ['line'],
        show: (widget) => R.pathOr(false, ['widgetRenderSettings', 'showDataLabels'], widget),
        group: 'Labels',
    },
    {
        name: 'rotateXAxisLabels',
        label: 'Rotate x axis labels',
        widgetRenderPath: 'rotateXAxisLabels',
        defaultValue: (widget) => R.pathOr(
            widget.xAxisLabels.length > 8,
            ['widgetRenderSettings', 'rotateXAxisLabels'],
            widget,
        ),
        type: 'checkbox',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line'],
        group: 'Labels',
    },
    {
        name: 'orientation',
        label: 'Orientation',
        widgetRenderPath: 'orientation',
        defaultValue: (widget) => R.pathOr(
            Number(R.pathOr(2, ['width'], widget)) < 4 ? 'vertical' : 'horizontal',
            ['widgetRenderSettings', 'orientation'],
            widget,
        ),
        options: [{ label: 'Vertical', value: 'vertical' }, { label: 'Horizontal', value: 'horizontal' }],
        type: 'select',
        allowedCharts: ['pie', 'donut'],
        group: 'Layout',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        name: 'swapSeriesXAxis',
        label: 'Swap series and X Axis',
        widgetRenderPath: 'swapSeriesXAxis',
        defaultValue: (widget) => R.pathOr(
            false,
            ['widgetRenderSettings', 'swapSeriesXAxis'],
            widget,
        ),
        type: 'checkbox',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line'],
        group: 'Data Settings',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        label: 'Format',
        name: 'format',
        widgetRenderPath: 'format',
        options: formatOptions,
        defaultValue: (widget) => R.pathOr(widget.isCurrency ? 'currency' : 'numeric',
            ['widgetRenderSettings', 'format'],
            widget),
        type: 'select',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'pie', 'donut', 'line', 'text', 'quadrantAnalysis', 'treemap'],
        group: 'Data Settings',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        label: 'Currency',
        name: 'currency',
        widgetRenderPath: 'currency',
        options: currencyOptions,
        defaultValue: (widget) => R.pathOr('USD',
            ['widgetRenderSettings', 'currency'],
            widget),
        type: 'select',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line', 'pie', 'donut', 'text', 'quadrantAnalysis', 'gauge', 'treemap'],
        show: (widget, showAdvancedSettings) => {
            if (!showAdvancedSettings) return false
            return R.pathOr(widget.isCurrency ? 'currency' : '', ['widgetRenderSettings', 'format'], widget) === 'currency'
        },
        group: 'Data Settings',
    },
    {
        name: 'showTitle',
        label: 'Show title',
        widgetRenderPath: 'showTitle',
        defaultValue: false,
        type: 'checkbox',
        onBlur: (control, value, changeSettings, widget) => {
            changeSettings(control, value)
            if (value) {
                changeSettings(
                    { widgetRenderPath: 'title' },
                    R.pathOr('', ['question', 'content', 'longTitle'], widget),
                )
            }
        },
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'pie', 'donut', 'radar', 'treemap', 'line', 'quadrantAnalysis', 'textResponse'],
        group: 'Title',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        name: 'title',
        label: 'Title',
        widgetRenderPath: 'title',
        defaultValue: (widget) => R.pathOr(
            R.pathOr('', ['question', 'content', 'longTitle', widget.langcode, 'text'], widget),
            ['widgetRenderSettings', 'title', widget.langcode, 'text'],
            widget,
        ),
        type: 'input',
        onBlur: (control, value, changeSettings, widget) => {
            changeSettings(
                { widgetRenderPath: 'title' },
                {
                    ...R.pathOr(
                        {},
                        ['widgetRenderSettings', 'title'],
                        widget,
                    ),
                    [widget.langcode]: { text: value },
                },
            )
        },
        show: (widget, showAdvancedSettings) => {
            if (!showAdvancedSettings) return false
            return R.pathOr(false, ['widgetRenderSettings', 'showTitle'], widget)
        },
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'pie', 'donut', 'radar', 'treemap', 'line', 'quadrantAnalysis', 'textResponse'],
        group: 'Title',
    },
    {
        label: 'Sort By',
        name: 'sortBy',
        widgetRenderPath: 'sortBy',
        options: sortByOptions,
        defaultValue: (widget) => R.pathOr(widget.scope === 'product' && widget.dashOid !== 6 ? 'endDate' : 'none',
            ['widgetRenderSettings', 'sortBy'],
            widget),
        type: 'select',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line'],
        group: 'Data Settings',
    },
    {
        label: 'Sort Direction',
        name: 'sortDirection',
        widgetRenderPath: 'sortDirection',
        options: sortDirections,
        defaultValue: (widget) => R.pathOr(1,
            ['widgetRenderSettings', 'sortDirection'],
            widget),
        type: 'select',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line'],
        group: 'Data Settings',
    },
    {
        name: 'showYAxis',
        label: 'Show Y axis',
        widgetRenderPath: 'showYAxis',
        defaultValue: true,
        type: 'checkbox',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line'],
        group: 'Style',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        name: 'scrollable',
        label: 'Scrollable',
        widgetRenderPath: 'scrollable',
        defaultValue: false,
        type: 'checkbox',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line'],
        group: 'Style',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        name: 'areaFill',
        label: 'Fill Area',
        widgetRenderPath: 'areaFill',
        defaultValue: false,
        type: 'checkbox',
        allowedCharts: ['radar'],
        group: 'Style',
    },
    {
        label: 'Colours',
        name: 'colors',
        key: 'colors',
        defaultOptions: (widget) => (R.pathOr([], ['fData', 0, 'data'], widget).map((d, i) => defaultColors[i % defaultColors.length])),
        onBlur: (widget, value, index, changeSettings, control) => {
            const newColors = R.pathOr([], ['fData', 0, 'data'], widget).map((dColor, i) => (i === index
                ? value
                : R.pathOr(defaultColors[i % defaultColors.length], ['widgetRenderSettings', 'colors', i], widget)))
            changeSettings(control, newColors)
        },
        type: 'colorPicker',
        widgetRenderPath: 'colors',
        allowedCharts: ['pie', 'donut'],
        group: 'Option Settings',
    },
    {
        label: 'Colours',
        name: 'colors',
        key: 'colors',
        defaultOptions: (widget) => (R.pathOr([], ['fData'], widget).map((d, i) => barDefaultColors[i % barDefaultColors.length])),
        onBlur: (widget, value, index, changeSettings, control) => {
            const newColors = R.pathOr([], ['fData'], widget).map((dColor, i) => (i === index
                ? value
                : R.pathOr(barDefaultColors[i % barDefaultColors.length], ['widgetRenderSettings', 'colors', i], widget)))
            changeSettings(control, newColors)
        },
        type: 'colorPicker',
        widgetRenderPath: 'colors',
        allowedCharts: ['column', 'bar', 'stackedColumn', 'stackedBar'],
        group: 'Option Settings',
    },
    {
        label: 'Colours',
        name: 'colors',
        key: 'colors',
        defaultOptions: () => (['#16CCC1']),
        onBlur: (widget, value, index, changeSettings, control) => {
            const newColors = ['#16CCC1'].map((dColor, i) => (i === index
                ? value
                : R.pathOr('#16CCC1', ['widgetRenderSettings', 'colors', i], widget)))
            changeSettings(control, newColors)
        },
        type: 'colorPicker',
        widgetRenderPath: 'colors',
        allowedCharts: ['textResponse'],
        group: 'Option Settings',
    },
    {
        label: 'Option names',
        name: 'option',
        key: 'optionNames',
        options: (widget) => (R.pathOr([], ['fData', 0, 'data'], widget).map(({ name }, i) => ({
            name,
            value: R.pathOr(name, ['widgetRenderSettings', 'option', name], widget),
            label: `label - ${i + 1}`,
        }))),
        defaultOptions: (widget) => R.pathOr([], ['fData', 0, 'data'], widget).map(({ name }) => name),
        onBlur: ({ value, name }, widget, control, editInputList) => {
            const defaultOptions = R.pathOr([], ['fData', 0, 'data'], widget).map((d) => d.name)
            editInputList(name, value, defaultOptions, control)
        },
        type: 'inputList',
        widgetRenderPath: 'option',
        allowedCharts: ['pie', 'donut'],
        group: 'Option Settings',
    },
    {
        label: 'Remove Zero/Null Values',
        name: 'removeZeroNull',
        widgetRenderPath: 'removeZeroNull',
        options: removeZeroNull,
        defaultValue: (widget) => R.pathOr('dontRemove',
            ['widgetRenderSettings', 'removeZeroNull'],
            widget),
        type: 'select',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'pie', 'donut', 'radar', 'treemap', 'line'],
        group: 'Data Settings',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        label: 'Decimal places',
        name: 'dataDecimals',
        widgetRenderPath: 'dataDecimals',
        options: [{ label: '0', value: 0 }, { label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }],
        defaultValue: (widget) => R.pathOr(0,
            ['widgetRenderSettings', 'dataDecimals'],
            widget),
        type: 'select',
        allowedCharts: ['gauge', 'text', 'lmx', 'column', 'bar', 'stackedBar', 'stackedColumn', 'pie', 'donut', 'radar', 'treemap', 'line', 'multiText'],
        group: 'Data Settings',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        label: 'Decimal places',
        name: 'dataDecimals',
        widgetRenderPath: 'dataDecimals',
        options: [{ label: '0', value: 0 }, { label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }],
        defaultValue: (widget) => R.pathOr(2,
            ['widgetRenderSettings', 'dataDecimals'],
            widget),
        type: 'select',
        allowedCharts: ['gauge0-5'],
        group: 'Data Settings',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        label: 'Benchmark Settings',
        name: 'allowedBenchmarks',
        widgetRenderPath: 'allowedBenchmarks',
        options: (widget, dashStore) => (
            dashStore.possibleBenchmarks[dashStore.oId].map((b) => (
                { value: b, label: dashStore.benchmarkLabels[b] }
            ))
        ),
        checkboxDefaultValue: (widget, dashStore, benchmark) => {
            const defaultValues = dashStore.possibleBenchmarks[dashStore.oId]
            return R.pathOr(defaultValues,
                ['widgetRenderSettings', 'allowedBenchmarks'],
                widget).includes(benchmark)
        },
        checkboxOnBlur: (changeSettings, benchmark, value, widget, dashStore) => {
            const defaultValues = dashStore.possibleBenchmarks[dashStore.oId]
            const currentValues = [...R.pathOr(defaultValues,
                ['widgetRenderSettings', 'allowedBenchmarks'],
                widget)]
            if (!value) {
                const indexOfBenchmark = currentValues.indexOf(benchmark)
                currentValues.splice(indexOfBenchmark, 1)
                changeSettings({ widgetRenderPath: 'allowedBenchmarks' }, currentValues)
            } else {
                changeSettings({ widgetRenderPath: 'allowedBenchmarks' }, [...currentValues, benchmark])
            }
        },
        selectLabel: 'Period',
        selectName: 'benchmarkPeriods',
        selectOptions: [{ value: 'ROL', label: 'Last 24 months' }, { value: 'ALL', label: 'All time' }],
        selectDefaultValue: (widget, benchmark) => R.pathOr('ROL',
            ['widgetRenderSettings', 'benchmarkPeriods', benchmark],
            widget),
        selectOnBlur: (changeSettings, benchmark, value, widget, dashStore) => {
            const currentValues = R.pathOr({},
                ['widgetRenderSettings', 'benchmarkPeriods'],
                widget)
            changeSettings({ widgetRenderPath: 'benchmarkPeriods' }, { ...currentValues, [benchmark]: value })
        },
        type: 'checkboxSelectGroup',
        allowedCharts: [],
        group: 'Benchmark Settings',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
    {
        label: 'Allowed benchmarks',
        name: 'allowedBenchmarks',
        widgetRenderPath: 'allowedBenchmarks',
        options: (widget, dashStore) => dashStore.possibleBenchmarks[dashStore.oId].map((b) => (
            { value: b, label: dashStore.benchmarkLabels[b] }
        )),
        defaultValue: (widget, dashStore) => {
            const defaultValues = dashStore.possibleBenchmarks[dashStore.oId]
            return R.pathOr(defaultValues,
                ['widgetRenderSettings', 'allowedBenchmarks'],
                widget)
        },
        type: 'checkboxGroup',
        allowedCharts: ['column', 'bar', 'stackedBar', 'stackedColumn', 'line'],
        group: 'Benchmark Settings',
        show: (widget, showAdvancedSettings) => (showAdvancedSettings),
    },
]

@observer
class DisplayOptions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openAccordian: '',
            showAdvancedSettings: false,
        }
    }

    changeSettings = (control, value) => {
        const { dashboardWizardStore, updatePreview } = this.props
        const {
            newWidget,
        } = dashboardWizardStore
        const { changeNewWidgetBulk } = newWidget

        const widgetRenderSettings = {
            ...newWidget.widgetRenderSettings,
            [control.widgetRenderPath]: value,
        }
        changeNewWidgetBulk([{ value: widgetRenderSettings, field: 'widgetRenderSettings' }])
        updatePreview()
    }

    editInputList = (prevName, value, options, control) => {
        const { dashboardWizardStore, updatePreview } = this.props
        const {
            newWidget,
        } = dashboardWizardStore
        const { changeNewWidgetBulk } = newWidget

        const optionValue = options.reduce((obj, o) => ({
            ...obj,
            [o]: o === prevName
                ? value
                : R.pathOr(o, ['widgetRenderSettings', control.name, o], newWidget),
        }), {})

        const widgetRenderSettings = {
            ...newWidget.widgetRenderSettings,
            [control.widgetRenderPath]: optionValue,
        }
        changeNewWidgetBulk([{ value: widgetRenderSettings, field: 'widgetRenderSettings' }])
        updatePreview()
    }

    renderControls = (control) => {
        const { dashboardWizardStore, widgetWithData } = this.props
        const { dashStore, newWidget } = dashboardWizardStore
        const { appStore } = dashStore
        const { langcode } = appStore
        const { formatData } = dashStore

        if (!widgetWithData) return null
        const { fData, xAxisLabels } = formatData(widgetWithData.data, widgetWithData)
        const widget = {
            ...widgetWithData,
            fData,
            xAxisLabels,
            question: newWidget.question,
            langcode,
            dashOid: dashStore.oId,
        }

        return {
            checkbox: () => (
                <div style={{ margin: '8px 0' }} key={control.name}>
                    <Slider
                        label={control.label}
                        name={control.name}
                        onChange={({ value }) => (control.onBlur && typeof control.onBlur === 'function'
                            ? control.onBlur(control, value, this.changeSettings, widget)
                            : this.changeSettings(control, value))}
                        defaultChecked={typeof control.defaultValue === 'function' ? control.defaultValue(widget) : R.pathOr(
                            control.defaultValue,
                            ['widgetRenderSettings', control.widgetRenderPath],
                            newWidget,
                        )}
                        value={R.pathOr(undefined, ['widgetRenderSettings', control.name], newWidget)}
                    />
                </div>
            ),
            checkboxGroup: () => (
                <div style={{ margin: '8px 0' }} key={control.name}>
                    <CheckboxGroup
                        label={control.label}
                        name={control.name}
                        key={control.key}
                        options={control.options(widget, dashStore)}
                        onBlur={({ value }) => this.changeSettings(control, value)}
                        defaultChecked={control.defaultValue(widget, dashStore)}
                        returnValueUnchanged
                    />
                </div>
            ),
            inputList: () => (
                <div key={control.name}>
                    <Typography type="b" style={{ margin: '4px 0 8px 0' }}>
                        {control.label}
                    </Typography>
                    <div style={{
                        marginBottom: '16px', overflow: 'auto', maxHeight: '200px', padding: '16px 8px', borderRadius: '8px', border: '0.3px solid #C7CFD8',
                    }}
                    >
                        {control.options(widget).map((field, i) => (
                            <div style={{
                                marginBottom: '16px', display: 'flex', flexDirection: 'column', gap: '8px', borderBottom: '1px solid #C7CFD8', paddingBottom: '4px',
                            }}
                            >
                                <Input
                                    label={field.label}
                                    name={field.name}
                                    key={control.key + field.label}
                                    defaultValue={field.value}
                                    onBlur={(value) => control.onBlur(
                                        value, widget, control, this.editInputList,
                                    )}
                                />
                                <Input
                                    label={`Default - ${field.label}`}
                                    name={`${field.name}default`}
                                    key={`${control.key + field.label}default`}
                                    defaultValue={control.defaultOptions(widget)[i]}
                                    disabled
                                />
                            </div>
                        ))}

                    </div>
                </div>
            ),
            // Here need to fix label position? Or maybe this is right and others are wrong really
            select: () => (
                <div style={{ marginTop: '16px', marginBottom: '8px', position: 'relative' }} key={control.name}>
                    <Select
                        label={control.label}
                        classNamePrefix="relative"
                        name={control.name}
                        options={control.options}
                        defaultValue={typeof control.defaultValue === 'function'
                            ? control.defaultValue(widget)
                            : R.pathOr(control.defaultValue, ['widgetRenderSettings', control.widgetRenderPath], widget)}
                        onBlur={({ value }) => this.changeSettings(control, value)}
                        blurOnClear
                        value={control.options
                            .find((v) => v.value === R.pathOr(undefined, ['widgetRenderSettings', control.name], newWidget)) || undefined}
                    />
                </div>
            ),
            input: () => (
                <div style={{ margin: '16px 0', position: 'relative' }} key={control.name}>
                    <Input
                        label={control.label}
                        name={control.name}
                        defaultValue={typeof control.defaultValue === 'function' ? control.defaultValue(widget) : R.pathOr(
                            control.defaultValue,
                            ['widgetRenderSettings', control.widgetRenderPath],
                            widget,
                        )}
                        onBlur={({ value }) => (control.onBlur && typeof control.onBlur === 'function'
                            ? control.onBlur(control, value, this.changeSettings, widget)
                            : this.changeSettings(control, value))}
                    />
                </div>
            ),
            colorPicker: () => (
                <div style={{ margin: '16px 0', position: 'relative' }} key={control.name}>
                    <Typography type="b" style={{ margin: '4px 0 8px 0' }}>
                        {control.label}
                    </Typography>
                    {control.defaultOptions(widget).map((c, i) => (
                        <div className="colorInputContainer">
                            <ColorPicker
                                name={i}
                                defaultValue={c}
                                onChange={(value, key) => {
                                    control.onBlur(widget, value, Number(key), this.changeSettings, control)
                                }}
                            />
                            <div className="colorPreview" style={{ backgroundColor: R.pathOr(c, ['widgetRenderSettings', 'colors', i], widget) }} />
                        </div>
                    ))}

                </div>
            ),
            checkboxSelectGroup: () => (
                <div style={{ margin: '16px 0', position: 'relative' }}>
                    {
                        control.options(widget, dashStore).map((o) => (
                            <div style={{ marginBottom: '16px' }}>
                                <Checkbox
                                    label={o.label}
                                    name={o.value}
                                    onBlur={({ value }) => (
                                        control.checkboxOnBlur(
                                            this.changeSettings, o.value, value, widget, dashStore,
                                        )
                                    )}
                                    checked={control.checkboxDefaultValue(widget, dashStore, o.value)}
                                    style={{ marginBottom: '16px' }}
                                />
                                <Select
                                    label={`${o.label} ${control.selectLabel}`}
                                    name={control.selectName}
                                    options={control.selectOptions}
                                    defaultValue={control.selectDefaultValue(widget, o.value)}
                                    onBlur={({ value }) => (
                                        control.selectOnBlur(
                                            this.changeSettings, o.value, value, widget, dashStore,
                                        )
                                    )}
                                    blurOnClear
                                />
                            </div>
                        ))
                    }
                </div>
            ),
        }[control.type]()
    }

    renderFields = () => {
        const { dashboardWizardStore, widgetWithData } = this.props
        const { dashStore, newWidget } = dashboardWizardStore
        const { chartType } = newWidget
        const { formatData } = dashStore
        if (!widgetWithData) return null
        const { fData, xAxisLabels } = formatData(widgetWithData.data, widgetWithData)
        const widget = {
            ...widgetWithData,
            ...newWidget,
            fData,
            xAxisLabels,
        }
        const { showAdvancedSettings } = this.state

        if (!chartType) return null
        const fields = settingOptions.filter((so) => so.allowedCharts.includes(chartType)
            && (so.show === undefined || so.show(widget, showAdvancedSettings)))
        if (!fields || !fields.length) return null

        const groupedFields = R.groupBy((field) => field.group)(fields)
        const renderGroups = this.getRenderGroups(groupedFields, widget, dashStore)

        return Object.keys(groupedFields)
            .filter((groupName) => renderGroups[groupName])
            .map((groupName) => (
                <div className="displayOptionsControlBlock">
                    <h4>{groupName}</h4>
                    <div className="accordianBody chartSizes">
                        {groupedFields[groupName]
                            .filter((f) => f.show === undefined || f.show(widget, showAdvancedSettings))
                            .map((c) => this.renderControls(c))}
                    </div>
                </div>
            ))
    }

    getRenderGroups = (groupFields, widget) => Object.keys(groupFields).reduce((acc, groupName) => {
        const group = groupFields[groupName]
        const render = group.some((field) => {
            if (field.type === 'colorPicker') {
                return typeof field.defaultOptions === 'function'
                    ? field.defaultOptions(widget).length > 0
                    : field.defaultOptions?.length > 0
            }
            if (field.type === 'select') {
                return typeof field.options === 'function'
                    ? field.options().length > 0
                    : field.options?.length > 0
            }
            return true
        })
        return {
            ...acc,
            [groupName]: render,
        }
    }, {})

    render() {
        const { showAdvancedSettings } = this.state
        const { dashboardWizardStore } = this.props
        const { renderWidgetDisplayOptions } = dashboardWizardStore

        return (
            <div className="chartSettings">
                <div style={{ margin: '8px 0 0 0', width: '115px' }} key="showAdvanced">
                    <Slider
                        label="Advanced"
                        name="showAdvanced"
                        onChange={() => this.setState({ showAdvancedSettings: !showAdvancedSettings })}
                        defaultChecked={false}
                    />
                </div>
                {renderWidgetDisplayOptions()}
                {this.renderFields()}
            </div>
        )
    }
}

export default DisplayOptions
